import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Collapse,
  Form,
  Modal,
  ModalBody,
} from "reactstrap";
import history from "../../history";
import InputText from "../InputText";
import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import Loader from "../Loader";
import MaterialTable from "material-table";
import DealerDetail from "../../components/DealerDetail";
import { fetchQueryParams } from "../../utils/comman";

import "../../assets/scss/components/MeterialTable/index.scss";
import get from "lodash/get";

const _ = { get };

export default class DealerListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      country: "",
      countryCode: "",
      count: 100,
      stateCode: "",
      state: "",
      page: 0,
      city: "",
      dealerName: "",
      dealerEmail: "",
      branchCode: "",
      dealerPhone: "",
      pageSize: 10,
      selectedId: "",
      toggleModal: false,
      countryList: [],
      parsedCountry: "",
    };
  }

  componentDidMount() {
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    if (queryParams) {
      let newState = { ...this.state };
      newState.page = params.page;
      newState.countryCode = params.countryCode;
      newState.branchCode = params.branchCode;
      newState.country = params.country;
      newState.state = params.state;
      newState.city = params.city;
      newState.dealerEmail = params.dealerEmail;
      newState.dealerPhone = params.dealerPhone;
      newState.dealerName = params.dealerName;
      newState.limit = params.count;
      this.setState({ ...newState });
      let data = {
        page: params.page !== "undefined" ? params.page : 0,
        country: params.countryCode !== "undefined" ? params.countryCode : "",
        state: params.state !== "undefined" ? params.state : "",
        city: params.city !== "undefined" ? params.city : "",
        phone: params.dealerPhone !== "undefined" ? params.dealerPhone : "",
        dealerName: params.dealerName !== "undefined" ? params.dealerName : "",
        emailId: params.dealerEmail !== "undefined" ? params.dealerEmail : "",
        branchCode: params.branchCode !== "undefined" ? params.branchCode : "",
        limit: params.count !== "undefined" ? params.count : 100,
      };
      this.props.handleFetchDealer(data);
      this.handleSetCountries();
      this.props.handleClearPreviousReducersForDealer();
    } else {
      let state = this.state;
      let data = {
        page: state.page,
        country: state.countryCode,
        state: state.state,
        city: state.city,
        dealerName: state.dealerName,
        branchCode: state.branchCode,
        emailId: state.dealerEmail,
        phone: state.dealerPhone,
        limit: state.count,
      };
      this.props.handleFetchDealer(data);
      this.handleSetCountries();
      this.props.handleClearPreviousReducersForDealer();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (prevProps.dealers.length !== this.props.dealers.length) {
      let state = this.state;

      state.page = Math.ceil(this.props.dealers.length / this.state.count);
      this.setState({ ...state });
    }
  }

  handleSetCountries = () => {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (accessibleCountries && accessibleCountries[0] === "*") {
      let state = this.state;
      state.countryList = countries;
      console.log("===Star state===", this.state.countryList);
      this.setState({ ...state });
    }
    if (accessibleCountries && accessibleCountries[0] !== "*") {
      let state = this.state;
      let newCountry = countries.filter((data) =>
        accessibleCountries.includes(data.locality.country)
      );
      state.countryList = newCountry;
      let code = newCountry[0].locality.country;
      let countryName = newCountry[0].country;

      state.countryCode = code;
      state.country = countryName;
      console.log("===Non Star state===", this.state.countryList);
      this.setState({ ...state });
    }
  };

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

handleOnPageChange = (page) => {
  const { dealers, dealerStatus, dealerCount } = this.props;
  const { pageSize, count } = this.state;

  const totalUIPages = Math.ceil(dealers.length / pageSize);
  const isLastPage = page === totalUIPages - 1;
  const hasMoreData = dealers.length < dealerCount;

  if (isLastPage && !dealerStatus && hasMoreData) {
    const nextApiPage = this.state.page + 1;

    this.setState({ page: nextApiPage });

    this.props.handleFetchDealer({
      page:  this.state.page ,
      country: this.state.countryCode,
      state: this.state.state,
      city: this.state.city,
      dealerName: this.state.dealerName,
      branchCode: this.state.branchCode,
      emailId: this.state.dealerEmail,
      phone: this.state.dealerPhone,
      limit: count, // 100
    });
  }
};



  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "") {
      let parsedValue = JSON.parse(e.target.value);
      state.countryCode = parsedValue.locality.country;
      state.country = parsedValue.country;
      state.state = "";
      state.city = "";
    } else {
      state.countryCode = "";
      state.country = "";
    }
    state.parsedCountry = e.target.value;
    this.setState({ ...state });
    this.props.handleFetchState(state.countryCode);
  };

  handleStateChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.state = parsedValue;
      state.city = "";
    }
    this.setState({ ...state });
    let data = {
      countryCode: state.countryCode,
      state: state.state,
    };
    this.props.handleFetchCity(data);
  };

  handleCityChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.city = parsedValue.cityName;
    }
    this.setState({ ...state });
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleRowData = (rowData) => {
    let newState = { ...this.state };
    newState.selectedId = rowData._id;
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleSubmitFilter = (e) => {
    history.replace("/dealer/list");
    e.preventDefault();

    let state = this.state;

    let data = {
      page: 0,
      country: state.countryCode,
      state: state.state,
      city: state.city,
      emailId: state.dealerEmail.toLowerCase().trim(),
      phone: state.dealerPhone.trim(),
      dealerName: state.dealerName,
      branchCode: state.branchCode,
      limit: state.count,
    };
    this.props.handleFetchDealer(data);
    this.props.handleClearPreviousReducersForDealer();
  };

  handleClearFilter = () => {
    let state = this.state;
    state.page = 0;
    state.country = "";
    state.countryCode = "";
    state.state = "";
    state.city = "";
    state.dealerEmail = "";
    state.dealerPhone = "";
    state.branchCode = "";
    state.dealerName = "";
    state.count = 100;
    state.parsedCountry = "";
    this.setState({ ...state });
    let data = {
      page: 0,
      country: "",
      state: "",
      city: "",
      emailId: "",
      branchCode: "",
      phone: "",
      dealerName: "",
      limit: 100,
    };
    this.props.handleFetchDealer(data);
    this.props.handleClearPreviousReducersForDealer();
  };

  render() {
    let { elements } = this.props;
    return (
      <div className="hideSearch">
        {this.props.dealerStatus !== false ? <Loader /> : null}

        <Form onSubmit={this.handleSubmitFilter}>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "dealersListingFilterElements.headingElement",
                  "Dealers"
                )}
                Name={_.get(
                  elements,
                  "dealersListingFilterElements.filterButtonElement",
                  "Filter"
                )}
                iconClass={"hideexcel"}
                handleToggle={() => this.handleToggle()}
                textTitle={_.get(
                  elements,
                  "dealersListingFilterElements.totalCountElement",
                  "Total Count - "
                )}
                preRegisteredUserCount={this.props.dealerCount}
              />
            </Col>
            <Col sm={12}>
              <Collapse isOpen={this.state.toggleActive}>
                <Card className="mb-3">
                  <CardBody>
                    <Row>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <FormGroup className=" confirmRiderSelect select_options">
                          {this.props.accessibleCountries &&
                          this.props.accessibleCountries.length === 1 &&
                          this.props.accessibleCountries[0] !== "*" ? (
                            <Input
                              type="select"
                              name="City"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleCountryChange}
                              value={this.state.parsedCountry}
                            >
                              {this.state.countryList &&
                                this.state.countryList.length > 0 &&
                                this.state.countryList
                                  .sort((a, b) =>
                                    a.name > b.name
                                      ? 1
                                      : b.name > a.name
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={JSON.stringify(item)}
                                    >
                                      {item.country}
                                    </option>
                                  ))}
                            </Input>
                          ) : (
                            <Input
                              type="select"
                              name="City"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleCountryChange}
                              value={this.state.parsedCountry}
                            >
                              <option value="">
                                {_.get(
                                  elements,
                                  "dealersListingFilterElements.CountryLabel",
                                  "All Countries"
                                )}
                              </option>
                              {this.state.countryList &&
                                this.state.countryList.length > 0 &&
                                this.state.countryList
                                  .sort((a, b) =>
                                    a.name > b.name
                                      ? 1
                                      : b.name > a.name
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={JSON.stringify(item)}
                                    >
                                      {item.country}
                                    </option>
                                  ))}
                            </Input>
                          )}
                        </FormGroup>
                      </Col>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="branchType"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleStateChange}
                            value={this.state.state}
                          >
                            <option>
                              {this.state.state !== ""
                                ? this.state.state
                                : _.get(
                                    elements,
                                    "dealersListingFilterElements.selectStateLabel",
                                    "Select State"
                                  )}
                            </option>
                            {this.props.states
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={JSON.stringify(item)}
                                >
                                  {item}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="branchType"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleCityChange}
                            value={this.state.city}
                          >
                            <option>
                              {this.state.city !== ""
                                ? this.state.city
                                : _.get(
                                    elements,
                                    "dealersListingFilterElements.selectCityLabel",
                                    "Select City"
                                  )}
                            </option>
                            {this.props.cities
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={JSON.stringify(item)}
                                >
                                  {item.cityName}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <InputText
                          labelName={_.get(
                            elements,
                            "dealersListingFilterElements.dealerNameLabel",
                            "Dealer Name"
                          )}
                          inputType={"text"}
                          inputName={"dealerName"}
                          InputClass={"inputText"}
                          customValue={this.state.dealerName}
                          inputPlaceholder={_.get(
                            elements,
                            "dealersListingFilterElements.dealerNamePlaceholder",
                            "Dealer  Name"
                          )}
                          customOnChange={(e) => this.handleFilterChange(e)}
                        />
                      </Col>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <InputText
                          labelName={_.get(
                            elements,
                            "dealersListingFilterElements.branchCodeLabel",
                            "Branch Code"
                          )}
                          inputType={"text"}
                          inputName={"branchCode"}
                          InputClass={"inputText"}
                          customValue={this.state.branchCode}
                          inputPlaceholder={_.get(
                            elements,
                            "dealersListingFilterElements.branchCodePlaceholder",
                            "Branch Code"
                          )}
                          customOnChange={(e) => this.handleFilterChange(e)}
                        />
                      </Col>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <InputText
                          labelName={_.get(
                            elements,
                            "dealersListingFilterElements.emailLabel",
                            "Email"
                          )}
                          inputType={"email"}
                          inputName={"dealerEmail"}
                          InputClass={"inputText"}
                          customValue={this.state.dealerEmail}
                          inputPlaceholder={_.get(
                            elements,
                            "dealersListingFilterElements.emailPlaceholder",
                            "Email"
                          )}
                          customOnChange={(e) => this.handleFilterChange(e)}
                        />
                      </Col>
                      <Col xl={4} lg={4} md={6} sm={6} className="mb-3 mb-lg-0">
                        <InputText
                          labelName={_.get(
                            elements,
                            "dealersListingFilterElements.mobileLabel",
                            "Phone"
                          )}
                          inputType={"text"}
                          inputName={"dealerPhone"}
                          customValue={this.state.dealerPhone}
                          InputClass={"inputText"}
                          inputPlaceholder={_.get(
                            elements,
                            "dealersListingFilterElements.mobilePlaceholder",
                            "Phone"
                          )}
                          customOnChange={(e) => this.handleFilterChange(e)}
                        />
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                      <CustomButton
                        customType={"submit"}
                        name={_.get(
                          elements,
                          "dealersListingFilterElements.searchButtonElement",
                          "Search"
                        )}
                        customClass={"btn-outline-dark bg-none btnthemeColor"}
                      />
                      <CustomButton
                        customType={"button"}
                        name={_.get(
                          elements,
                          "dealersListingFilterElements.clearFilterButtonElement",
                          "Clear Filter"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={this.handleClearFilter}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Collapse>
            </Col>
          </Row>
        </Form>

        <Row>
          <Col sm="12">
            <div className="custom-m-table">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.dealerIdElement",
                      "Dealer Id"
                    ),
                    field: "dealerId",
                  },
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.nameElement",
                      "Name"
                    ),
                    field: "dealerName",
                  },
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.emailElement",
                      "Email"
                    ),
                    field: "emailId",
                  },
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.phoneElement",
                      "Phone"
                    ),
                    field: "phone",
                  },
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.clubCoordinatorNameElement",
                      "Club Coordinator's Name"
                    ),
                    field: "storeManagerName",
                  },
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.countryElement",
                      "Country"
                    ),
                    field: "country",
                  },
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.stateElement",
                      "State"
                    ),
                    field: "state",
                  },
                  {
                    title: _.get(
                      elements,
                      "dealerListTableElement.cityElement",
                      "City"
                    ),
                    field: "city",
                  },
                ]}
                data={this.props.dealers}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                actions={[
                  {
                    icon: "assignment_ind",
                    tooltip: "Detail Page",
                    onClick: (event, rowData) => this.handleRowData(rowData),
                  },
                ]}
                onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "dealerListTableElement.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "dealerListTableElement.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </div>
          </Col>
        </Row>
        <Modal
          isOpen={this.state.toggleModal}
          toggle={this.handleToggleModel}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <DealerDetail
              handleFetchDealer={this.props.handleFetchDealer}
              handleFetchCountry={this.props.handleFetchCountry}
              handleClearPreviousReducersForDealer={
                this.props.handleClearPreviousReducersForDealer
              }
              handleFetchState={this.props.handleFetchState}
              handleSelectedRowData={this.props.handleSelectedRowData}
              handleFetchCity={this.props.handleFetchCity}
              countryStatus={this.props.countryStatus}
              countries={this.props.countries}
              stateStatus={this.props.stateStatus}
              states={this.props.states}
              cityStatus={this.props.cityStatus}
              cities={this.props.cities}
              dealerStatus={this.props.dealerStatus}
              dealerCount={this.props.dealerCount}
              dealers={this.props.dealers}
              elements={this.props.elements}
              handleSingleDealerFetch={this.props.handleSingleDealerFetch}
              handleDealerBranchFetch={this.props.handleDealerBranchFetch}
              query={this.props.query}
              selectedRowData={this.state.selectedRowData}
              dealerDataStatus={this.props.dealerDataStatus}
              dealerData={this.props.dealerData}
              dealerBranchDataStatus={this.props.dealerBranchDataStatus}
              dealerBranchData={this.props.dealerBranchData}
              selectedId={this.state.selectedId}
              count={this.state.count}
              page={this.state.page}
              countryCode={this.state.countryCode}
              country={this.state.country}
              state={this.state.state}
              city={this.state.city}
              dealerEmail={this.state.dealerEmail}
              dealerPhone={this.state.dealerPhone}
              dealerId={this.state.dealerId}
              handleToggleModel={this.handleToggleModel}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
